import { IconButton, Tooltip } from "@material-ui/core";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import PropTypes from "prop-types";
import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";

function TextCopyButton(props) {
  const { text, tooltipTitle, ...rest } = props;
  const [tooltipTitleState, setTooltipTitleState] = useState(tooltipTitle);

  function handleClickCopy() {
    setTooltipTitleState("Copied");
    setTimeout(() => setTooltipTitleState(tooltipTitle), 2000);
  }

  return (
    <CopyToClipboard text={text} onCopy={handleClickCopy}>
      <Tooltip title={tooltipTitleState} placement="top" arrow interactive leaveDelay={1500}>
        <IconButton {...rest} style={{ padding: "8px", fontSize: "inherit" }}>
          <FileCopyOutlinedIcon style={{ fontSize: "inherit" }} />
        </IconButton>
      </Tooltip>
    </CopyToClipboard>
  );
}

export default TextCopyButton;

TextCopyButton.propTypes = {
  ...IconButton.propTypes,
  text: PropTypes.string.isRequired,
  tooltipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

TextCopyButton.defaultProps = {
  text: "",
  size: "medium",
  tooltipTitle: "Copy",
};
